import React, { useState } from 'react'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import LinkOutlinedIcon from 'components/material-symbol/icons/Link'
import EventDetailsDialog from '../../pga-coach/bookings/events/event-details-dialog'
import ShareEventDialog from 'components/group-events/share-event-dialog'
import ActionMenu from './action-menu'
import EventCard from 'components/group-events/event-card'

const ConsumerEventCard = ({ event, openEvent }) => {
  const [isDetailsOpen, setIsDetailsOpen] = useState(
    openEvent ? 'detail' : null,
  )
  const [isShareOpen, setIsShareOpen] = useState(false)

  return (
    <EventCard
      event={event}
      setIsDetailsOpen={setIsDetailsOpen}
      cardActions={
        <>
          <Tooltip title="Share">
            <IconButton
              aria-label="Share"
              onClick={() => setIsShareOpen(!isShareOpen)}
            >
              <LinkOutlinedIcon color="primary" />
            </IconButton>
          </Tooltip>
          <ShareEventDialog
            isOpen={isShareOpen}
            url={event.eventUrl}
            title={event.title}
            setIsOpen={setIsShareOpen}
            titleText="Share this event"
          />
          <EventDetailsDialog
            isOpen={isDetailsOpen}
            event={event}
            setIsOpen={setIsDetailsOpen}
          />
        </>
      }
      actionMenu={<ActionMenu setIsShareOpen={setIsShareOpen} />}
    />
  )
}

export default ConsumerEventCard
